<template>
  <div class="Discover">
    <button class="round-btn" @click="closeModal">
      <img
        src="img/02_generales/cerrar.png"
        alt="close button"
      />
    </button>

    <div v-if="section" class="wrapper">
      <h2 class="title">
        {{ $t("s-discover") }}
      </h2>
      <div class="content-wrapper" v-html="getDescription"></div>
    </div>
    <transition name="fade" mode="out-in">
      <Gallery :images="plainGallery" :index="selectedImageIndex" v-if="galleryIsShown"></Gallery>
    </transition>
  </div>
</template>

<script>
import Gallery from "@/components/Gallery.vue";
import { Analytic } from "../../public/js/analytics/Analytic.js";
var options = {
  url: "./setAnalytic.php",
  idPag: 1,
  namePag: "Discover",
};
var analytic = new Analytic(options);
export default {
  name: "Discover",
  async mounted() {
    await this.$nextTick();
    analytic.registerEvent(`Discover`, "open");
    this.$root.$emit("initSidebarWith", "discover");
    this.section = this.$store.state.parkData["discover"];
  },
  updated() {
    document.querySelectorAll('.imgA').forEach(item => {
      item.addEventListener('click', event => {
        this.selectedImageIndex = event.target.dataset.img;
        this.openGallery();
      })
    })
  },
  components: {
    Gallery
  },
  deactivated() {
    analytic.registerEvent(`Discover`, "closed");
  },
  data() {
    return {
      section: null,
      galleryIsShown: false,
      selectedImage: null,
      selectedImageIndex: null,
      gallery: [],
    };
  },
  computed: {
    getDescription() {
      return this.$store.state.parkData["discover"].text;
    },
    plainGallery() {
      if (this.gallery == null || this.gallery == undefined) {
        return [];
      }

      return this.gallery.map((item) => {
        return require(`@/assets/info/${item.src}`);
      });
    },
  },
  methods: {
    closeModal() {
      this.$router.go(-1);
    },
    openGallery() {
      this.gallery = [];
      this.gallery.push({ "src": "Intersect@2x.png" }, { "src": "Intersect@2x-1.png" }, { "src": "Screenshot 2021-09-17 at 12.51 1@2x.jpg" });
      this.galleryIsShown = true;
    },
    closeGallery() {
      this.galleryIsShown = false;
    },
  },
};
</script>

<style lang="scss">
.Discover {
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--app-bg);
  display: flex;
  flex-flow: column;
  justify-content: flex-end;
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .wrapper {
    position: relative;
    display: flex;
    flex: 1;
    flex-flow: column;
    align-items: center;
    margin: 0rem 1.7rem;
    overflow: hidden;
    max-height: 90%;
    margin-top: 7.5rem;

    .title {
      font-family: "Myriad-bold";
      font-size: 2rem;
      text-align: left;
      margin: 1rem 0 0 0;
      align-self: flex-start;
      color: #5c5c5c;
      &.special {
        font-family: "Myriad-bold";
        &.centro {
          text-align: center;
          width: 100%;
          line-height: 2rem;
        }
      }
    }

    .content-wrapper {
      position: relative;
      flex: 1;
      margin: 1rem 0;
      width: 100%;
      overflow: auto;
      text-align: initial;
      font-size: 1.2rem;
      line-height: 1.6rem;
      padding-right: 1.5rem;
      mask-image: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 1) 2%,
        rgba(0, 0, 0, 1) 98%,
        rgba(0, 0, 0, 0) 100%
      );
      -webkit-mask-image: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 1) 2%,
        rgba(0, 0, 0, 1) 98%,
        rgba(0, 0, 0, 0) 100%
      );
      padding: 1rem 0rem;
      align-items: center;
      display: flex;
      flex-flow: column;
      p {
        text-align: center;
        font-size: 1.25rem;
        line-height: 2rem;
        margin-bottom: 3rem;
        color: #272727;
        font-family: "Lato";
        &:last-of-type {
          padding-bottom: 1rem;
        }
        span {
          display: inline-block;
          width: 45%;
          text-align: right;
          &.center1 {
            text-align: center;
            font-family: "Myriad-bold";
            margin-bottom: 1rem;
            border-bottom: 4px solid #e4a709;
          }
        }
        &.center {
          text-align: center;
          margin-top: 1rem;
          margin-bottom: 2rem;
          &:last-of-type {
            padding-bottom: 1rem;
          }
        }
        &.left {
          text-align: left;
          padding-right: 0.8rem;
          margin-top: 1rem;
          margin-bottom: 1rem;
          &:last-of-type {
            padding-bottom: 1rem;
          }
        }
        &.center1 {
          align-self: center;
          text-align: center;
          &:last-of-type {
            padding-top: 4rem;
          }
        }
      }
      span.center1 {
        text-align: center;
        font-size: 1.5rem;
        font-family: "Myriad-bold";
        margin-bottom: 1rem;
        border-bottom: 4px solid #e4a709;
      }
      img {
        margin-bottom: 2rem;
        &.img {
          width: 100%;
        }
        &.img1 {
          width: 100px;
          &.sub2 {
            margin: 0 1rem;
          }
        }
        &.img2 {
          width: 100%;
        }
        &.img3 {
          width: 100%;
        }
        &.imgw {
          width: 127px;
        }
        &.imgcm {
          width: 167px;
        }
      }
    }
  }
}
</style>
